"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInvestorInvitationStatusTrads = void 0;
exports.EInvestorInvitationStatusTrads = {
    sent: "Envoyée",
    opened: "Ouverte",
    in_progress: "En cours de saisie",
    submitted: "Dossier envoyé",
    revoked: "Révoquée",
};
